<template>
  <div id="login" class="container-fluid">
    <PasswordReset
      v-if="showPasswordReset"
      @close="togglePasswordReset()"
    ></PasswordReset>
    <section class="row">
      <div :class="{ 'signup-form': !showLoginForm }" class="col-4">
        <form v-if="showLoginForm" @submit.prevent ref="login">
          <h1>{{ $t("message.welcome_back") | capitalize }}</h1>
          <div class="form-group">
            <label for="email1">{{ $t("message.email") | capitalize }}</label>
            <input
              class="form-control"
              v-model.trim="loginForm.email"
              type="text"
              placeholder
              id="email1"
            />
          </div>
          <div class="form-group">
            <label for="password1">{{
              $t("message.password") | capitalize
            }}</label>
            <input
              class="form-control"
              v-model.trim="loginForm.password"
              type="password"
              placeholder="******"
              id="password1"
            />
          </div>
          <div class="form-group">
            <button @click="login()" class="btn btn-primary button">
              {{ $t("message.login") | title }}
            </button>
          </div>
          <div class="extras form-group">
            <a v-b-modal.password-reset class="btn btn-sm btn-light">{{
              $t("message.forgot_password") | title
            }}</a>
            <a @click="toggleForm()" class="btn btn-sm btn-success">{{
              $t("message.create_account") | title
            }}</a>
          </div>
        </form>
        <form v-else @submit.prevent ref="reg">
          <h1>{{ $t("message.register") | capitalize }}</h1>
          <name-field v-model.trim="signupForm.name"></name-field>
          <div class="form-group">
            <label for="email2">{{ $t("message.email") | capitalize }}</label>
            <input
              class="form-control"
              v-model.trim="signupForm.email"
              type="text"
              placeholder
              id="email2"
              required
            />
          </div>
          <div class="form-group">
            <label for="password2">{{
              $t("message.password") | capitalize
            }}</label>
            <input
              class="form-control"
              v-model.trim="signupForm.password"
              type="password"
              :placeholder="$t('message.minsix') | capitalize"
              id="password2"
              minlength="6"
              required
            />
          </div>
          <div class="form-group">
            <label for="password3">{{
              $t("message.confirm_password") | capitalize
            }}</label>
            <input
              class="form-control"
              v-model.trim="signupForm.password_confirm"
              type="password"
              :placeholder="$t('message.minsix') | capitalize"
              id="password3"
              minlength="6"
              required
            />
          </div>
          <!--delete after beta period-->
          <div class="form-group">
            <label for="betakey">{{ $t("message.beta_key") | title }}</label>
            <input
              class="form-control"
              v-model.trim="signupForm.betakey"
              type="text"
              id="betakey"
              minlength="6"
              required
            />
          </div>
          <button @click="signup()" class="btn btn-primary">
            {{ $t("message.signup") }}
          </button>
          <div class="extras">
            <a href="#" @click="toggleForm()">{{ $t("message.back_login") }}</a>
          </div>
        </form>
      </div>
    </section>
  </div>
</template>

<script>
import PasswordReset from "@/components/PasswordReset";
import NameField from "@/components/NameField";
import { keysCollection } from "@/firebase";
export default {
  components: {
    PasswordReset,
    NameField
  },
  props: {
    showReg: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loginForm: {
        email: "",
        password: ""
      },
      signupForm: {
        name: "",
        email: "",
        password: "",
        password_confirm: "",
        betakey: ""
      },
      showLoginForm: true,
      showPasswordReset: true
    };
  },
  mounted() {
    this.showLoginForm = !this.showReg;
    console.log("show reg", this.showReg);
  },
  watch: {
    showReg() {
      this.showLoginForm = !this.showReg;
    }
  },
  methods: {
    toggleForm() {
      this.showLoginForm = !this.showLoginForm;
    },
    togglePasswordReset() {
      this.showPasswordReset = !this.showPasswordReset;
    },
    login() {
      this.$store.dispatch("login", {
        email: this.loginForm.email,
        password: this.loginForm.password
      });
    },
    async signup() {
      if (this.$refs.reg.checkValidity()) {
        if (this.signupForm.password != this.signupForm.password_confirm) {
          return;
        }
        if (this.signupForm.betakey.length == 0) {
          return;
        }
        const self = this;
        keysCollection
          .doc(this.signupForm.betakey)
          .get()
          .then(doc => {
            if (doc.exists && !doc.data().taken) {
              this.$store
                .dispatch("signup", {
                  email: this.signupForm.email,
                  password: this.signupForm.password,
                  name: this.signupForm.name,
                  beta: this.signupForm.betakey //TODO remove
                })
                .then(() => {
                  let message = self.$t("message.register_success");

                  self.flashMessage.show({
                    status: "success",
                    message: self.$options.filters.capitalize(message)
                  });
                })
                .catch(function(err) {
                  console.log(err);
                  let message = self.$t("message.register_error");
                  self.flashMessage.show({
                    status: "error",
                    message: self.$options.filters.capitalize(message)
                  });
                });
            } else {
              self.signupForm.betakey = "";
              let message = self.$t("message.invalid_beta_key");
              self.flashMessage.show({
                status: "error",
                message: self.$options.filters.capitalize(message)
              });
            }
          })
          .catch(err => {
            console.log(err);
            self.signupForm.betakey = "";
            let message = self.$t("message.invalid_beta_key");
            self.flashMessage.show({
              status: "error",
              message: self.$options.filters.capitalize(message)
            });
          });
      } else {
        this.$refs.reg.reportValidity();
      }
    }
  }
};
</script>
<style lang="scss" scoped></style>
